export const BASE_URL = process.env.REACT_APP_BASE_URL || 'https://tironem.azurewebsites.net/api';

export const BASE_URL_PREFIX =
  process.env.REACT_APP_BASE_URL_PREFIX || 'https://tironem.azurewebsites.net';

